import { Routes } from '@angular/router';
import { AuthGuard } from '@core/services/auth/auth-guard.service';
import { SETTINGS_ROUTES } from '@modules/settings/settings.routes';
import { WORKFLOW_ROUTES } from '@modules/workflows/workflows.routes';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('@shared/components/empty-page/empty-page.component').then(m => m.EmptyPageComponent)
  },
  {
    path: 'plans',
    loadComponent: () => import('@modules/plans/plans.component').then(m => m.PlansComponent),
    canActivate: [AuthGuard]
  },
  // Each settings page has its own gate: Account is open to every user.
  {
    path: 'settings',
    children: SETTINGS_ROUTES,
    data: { breadcrumb: [{ label: 'Settings' }] },
    canActivate: [AuthGuard]
  },
  ...WORKFLOW_ROUTES,
  { path: 'connectors', redirectTo: '/connections' },
  {
    path: '404',
    loadComponent: () => import('@shared/components/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent)
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];
